import React, { useEffect, useState } from "react";
import displayINRCurrency from "../helpers/displayCurrency";
import { useNavigate } from "react-router-dom";

const Checkout = () => {

  const [cartItems, setCartItems] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cod");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchCart();
    fetchAddresses();
  }, []);

  // 🔥 FETCH CART
  const fetchCart = async () => {
    const res = await fetch(
      "https://lappyshop.onrender.com/api/view-card-product",
      { credentials: "include" }
    );

    const data = await res.json();
    if (data.success) setCartItems(data.data);
  };

  // 🔥 FETCH ADDRESS
  const fetchAddresses = async () => {
    const res = await fetch(
      "https://lappyshop.onrender.com/api/get-address",
      { credentials: "include" }
    );

    const data = await res.json();

    if (data.success) {
      setAddresses(data.data);

      const defaultAddress = data.data.find(a => a.isDefault);
      if (defaultAddress) setSelectedAddress(defaultAddress._id);
    }
  };

  // 🔥 PRICE FIX (MOST IMPORTANT)
  const getPrice = (item) => {
    return (
      item?.price ||                         // ✅ cart price
      item?.productId?.sellingPrice ||       // fallback
      item?.productId?.price ||              // fallback
      0
    );
  };

  // 🔥 TOTAL FIX
  const totalPrice = cartItems.reduce(
    (prev, curr) => prev + curr.quantity * getPrice(curr),
    0
  );

  // 🔥 PLACE ORDER
  const placeOrder = async () => {

    if (!selectedAddress) {
      alert("Please select address");
      return;
    }

    /* ---------------- COD ---------------- */
    if (paymentMethod === "cod") {

      const res = await fetch(
        "https://lappyshop.onrender.com/api/create-order-cod",
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            addressId: selectedAddress,
            paymentMethod: "cod"
          })
        }
      );

      const data = await res.json();

      if (data.success) navigate("/order-success");
      else alert(data.message);

      return;
    }

    /* ---------------- RAZORPAY ---------------- */
    if (paymentMethod === "razorpay") {

      if (!window.Razorpay) {
        alert("Razorpay SDK not loaded");
        return;
      }

      setLoading(true);

      const res = await fetch(
        "https://lappyshop.onrender.com/api/create-razorpay-order",
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            addressId: selectedAddress,
            paymentMethod: "razorpay"
          })
        }
      );

      const data = await res.json();

      if (!data.success) {
        alert(data.message);
        setLoading(false);
        return;
      }

      const options = {
        // key: process.env.REACT_APP_RAZORPAY_KEY,
        key: "rzp_live_SPrq2OQEHiH2dl",
        amount: data.data.amount,
        currency: "INR",
        name: "LappyShop",
        description: "Order Payment",
        order_id: data.data.id,

        handler: async function (response) {

          const verify = await fetch(
            "https://lappyshop.onrender.com/api/verify-payment",
            {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(response)
            }
          );

          const verifyData = await verify.json();
          setLoading(false);

          if (verifyData.success) {
            window.location.href = "/order-success";
          } else {
            alert("Payment verification failed");
          }
        }
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function () {
        alert("Payment Failed ❌");
        setLoading(false);
      });

      rzp.open();
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen py-8">

      <div className="container mx-auto px-4">

        <h1 className="text-3xl font-semibold mb-6">
          Checkout
        </h1>

        <div className="grid lg:grid-cols-3 gap-8">

          {/* LEFT */}
          <div className="lg:col-span-2 space-y-6">

            {/* ADDRESS */}
            <div className="bg-white p-6 rounded shadow">

              <h2 className="font-semibold mb-4">
                Delivery Address
              </h2>

              {addresses.map(addr => (

                <label
                  key={addr._id}
                  className="flex gap-3 border p-3 rounded mb-3 cursor-pointer"
                >

                  <input
                    type="radio"
                    checked={selectedAddress === addr._id}
                    onChange={() => setSelectedAddress(addr._id)}
                  />

                  <div>
                    <p className="font-medium">{addr.fullName}</p>

                    <p className="text-sm text-gray-600">
                      {addr.addressLine}, {addr.city}, {addr.state} - {addr.pincode}
                    </p>

                    <p className="text-sm text-gray-500">
                      Phone: {addr.phone}
                    </p>
                  </div>

                </label>

              ))}

              <button
                onClick={() => navigate("/account/address")}
                className="text-blue-600 text-sm mt-2"
              >
                + Add New Address
              </button>

            </div>

            {/* PAYMENT */}
            <div className="bg-white p-6 rounded shadow">

              <h2 className="font-semibold mb-4">
                Payment Method
              </h2>

              <label className="flex items-center gap-3 border p-3 rounded mb-3 cursor-pointer">
                <input
                  type="radio"
                  checked={paymentMethod === "cod"}
                  onChange={() => setPaymentMethod("cod")}
                />
                <div>
                  <p className="font-medium">Cash on Delivery</p>
                  <p className="text-sm text-gray-500">
                    Pay when product arrives
                  </p>
                </div>
              </label>

              <label className="flex items-center gap-3 border p-3 rounded cursor-pointer">
                <input
                  type="radio"
                  checked={paymentMethod === "razorpay"}
                  onChange={() => setPaymentMethod("razorpay")}
                />
                <div>
                  <p className="font-medium">Pay Online (Razorpay)</p>
                  <p className="text-sm text-gray-500">
                    UPI / Card / Netbanking
                  </p>
                </div>
              </label>

            </div>

          </div>

          {/* RIGHT */}
          <div className="bg-white p-6 rounded shadow h-fit">

            <h2 className="font-semibold mb-4">
              Order Summary
            </h2>

            {cartItems.map(item => (

              <div
                key={item._id}
                className="flex justify-between items-center mb-3"
              >

                <span>
                  {item.productId?.productName} × {item.quantity}
                </span>

                <span>
                  {displayINRCurrency(
                    item.quantity * getPrice(item)
                  )}
                </span>

              </div>

            ))}

            <div className="border-t mt-4 pt-4 flex justify-between font-semibold">

              <span>Total</span>

              <span>
                {displayINRCurrency(totalPrice)}
              </span>

            </div>

            <button
              onClick={placeOrder}
              disabled={loading}
              className="w-full bg-black text-white py-3 rounded mt-4 hover:opacity-90"
            >
              {loading ? "Processing..." : "Place Order"}
            </button>

            <p className="text-xs text-gray-500 mt-3 text-center">
              Secure Checkout • SSL Protected
            </p>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Checkout;